import { Turbo } from '@hotwired/turbo';

function cleanupReactRoots() {
  const reactRoots = [
    ...(document.querySelectorAll('[data-js-selector]') || []),
    ...(document.querySelectorAll('[data-react-initialized="true"]') || []),
  ];

  reactRoots.forEach((container) => {
    if (container._reactRoot) {
      container._reactRoot.unmount();
      container._reactRoot = null;
      if (container.dataset.reactInitialized) {
        container.dataset.reactInitialized = 'false';
      }
    }
  });
}

//document.addEventListener('turbo:before-cache', cleanupReactRoots);
document.addEventListener('turbo:before-render', cleanupReactRoots);

// Mark when Turbo has finished loading
document.addEventListener('turbo:load', () => {
  document.body.setAttribute('data-turbo-loaded', 'true');
});
